<template>
  <admin-card title="Добавление пользователя" :show-partners-block="false">
    <form @submit.prevent="create" @keydown="form.onKeydown($event)">
      <!-- User Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('user_name') }}</label>
        <div class="col-md-7">
          <input v-model="form.name" type="text" name="name" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('name') }">
          <has-error :form="form" field="name"></has-error>
        </div>
      </div>

      <!-- User email -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('user_email') }}</label>
        <div class="col-md-7">
          <input v-model="form.email" type="email" name="email" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('email') }">
          <has-error :form="form" field="email"></has-error>
        </div>
      </div>

      <!-- User password -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('user_password') }}</label>
        <div class="col-md-7">
          <input v-model="form.password" type="text" name="password" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('password') }">
          <has-error :form="form" field="password"></has-error>
        </div>
      </div>

      <!-- User Roles -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('user_role') }}</label>
        <div class="col-md-7">
          <select v-model="form.roles"
                  class="form-control"
                  name="roles"
                  multiple
                  :class="{ 'is-invalid': form.errors.has('roles') }">
            <option v-for="role in roles" v-bind:value="role.name">
              {{ role.display_name }}
            </option>
          </select>
          <has-error :form="form" field="roles"></has-error>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button type="success" :loading="form.busy">{{ $t('create') }}</v-button>
        </div>
      </div>
    </form>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: this.$t('add_user') }
    },
    extends: AdminPage,
    computed: mapGetters({
      users: 'users/users',
      roles: 'roles/roles'
    }),
    data: () => ({
      form: new Form({
        name: '',
        email: '',
        password: '',
        roles: [],
      })
    }),
    methods: {
      async create () {
        this.$store.dispatch('users/create', this.form);
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      }
    },
    beforeMount () {
      this.$store.dispatch('roles/fetchRoles');
    }
  }
</script>
